import { PrimaryButton } from 'commonStyledComponents'
import styled from 'styled-components'

export const TooltipWrapper = styled.div`
  position: fixed;
  left: calc(16rem / 39);
  right: calc(16rem / 39);
  bottom: calc(env(safe-area-inset-bottom) + calc(24rem / 39));
  z-index: calc(var(--layer-fullpage-modal) + 1);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: calc(12rem / 39);
  padding: calc(13rem / 39) calc(16rem / 39);
  border-radius: calc(8rem / 39);
  background-color: var(--main-background);
  box-shadow: 0 calc(4rem / 39) calc(9rem / 39) rgba(0, 0, 0, 0.5);
  color: var(--main-color);
`

export const TooltipText = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  font-size: calc(14rem / 39);
  font-weight: 600;
  line-height: 150%;
`

export const TooltipButton = styled(PrimaryButton)`
  flex: 0 0 auto;
  padding: calc(4rem / 39) calc(10rem / 39);
  border-radius: calc(4rem / 39);
  font-size: calc(14rem / 39);
  font-weight: 600;
  line-height: 150%;
`
